fx.ns("models", class User extends fx.Model {

	constructor(data) {
		super(data);
	}

	get isRegistered() {
		return !!this.email;
	}

	login(email, password, creationid, accountid) {
		this.event("login-sent");

		let credentials = {
			email: email,
			password: password,
			creationid: creationid,
			accountid: accountid
		};

		// in the mobile app Flutter performs the call itself (it owns the installation id)
		if (fx.get("flutter"))
			fx.get("flutter").Login(credentials, this._logged.bind(this));
		else
			this.post("/app/login", credentials, this._logged);
	}

	_logged(data) {
		if (data.failed || data.error)
			this.event("login-failed", data);
		else {
			//this.init(data);
            this.setData(data, "login-succeed");
			//this.event("login-succeed");
		}
	}

    setData(data, event)
    {
        this.init(data);

        if (event)
            this.event(event);
    }


	register(email, password, creationid, accountid) {
		this.event("register-sent");

		let credentials = {
			email: email,
			password: password,
			creationid: creationid,
			accountid: accountid
		};

		// in the mobile app Flutter performs the call itself, mirroring login()
		if (fx.get("flutter"))
			fx.get("flutter").Register(credentials, this._registered.bind(this));
		else
			this.post("/app/register", credentials, this._registered);
	}

	_registered(data) {
		if (data.failed || data.error)
			this.event("register-failed", data);
		else {
			//this.init(data);
			//this.event("register-succeed");
            this.setData(data, "register-succeed");
		}
	}

	get device() {
		return fx.get("app-device") || "";
	}

	get project() {
		return fx.get("app") || "";
	}

	// User Notifications (used for help bubbles : choose your cover, crop picture, etc...)
	wasNotificated() {
		let notifications = this.notifications ? JSON.parse(this.notifications) : {};

		let notificated = true;
		for (let i = 0; i < arguments.length; i++)
			notificated = notificated && !!notifications[this.device + "-" + this.project + "-" + arguments[i]];

		return notificated;
	}

	notificated(name) {
		let notifications = this.notifications ? JSON.parse(this.notifications) : {};

		notifications[this.device + "-" + this.project + "-" + name] = true;

		this.notifications = JSON.stringify(notifications);
	}

	// the same, once for the whole account : on any device, in any editor
	wasNotificatedForAccount(name) {
		let notifications = this.notifications ? JSON.parse(this.notifications) : {};

		return !!notifications[name];
	}

	notificatedForAccount(name) {
		let notifications = this.notifications ? JSON.parse(this.notifications) : {};

		notifications[name] = true;

		this.notifications = JSON.stringify(notifications);
	}

});